import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f6bac70"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-left px-[16px] flex" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "title font-20" }, "Compartilhar")
], -1))

import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import {
  PermissionResponse,
  PermissionType,
  ResourceType
} from '@/Network/Types/Responses/PermissionResponses'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'


export default /*#__PURE__*/_defineComponent({
  __name: 'share.policy.modal',
  setup(__props) {

const modalName = EModals.SHARE_POLICY
const { modals } = storeToRefs(useModalStore())
const modalStore = useModalStore()
const permissionsStore = usePermissionsStore()

const canEditCompanyAccess = computed(() => {
  return permissionsStore.checkAnyRessources({
    permission: AuthorizationPermissions.AccessLevelEditing,
    resourceType: AuthorizationResourcesAndSubjects.Company
  })
})

const handleToggleModal = () => {
  clearFields()
  modalStore.toggleModal(modalName)
}
const isShareContext = ref(false)
const isUnauthorize = ref(false)

const permissionsData = ref<PermissionResponse[]>([])

const permission = ref<PermissionType>(PermissionType.Admin)
const permissionNewUsers = ref([
  {
    label: 'Leitor',
    value: PermissionType.View
  },
  {
    label: 'Editor',
    value: PermissionType.Admin
  }
])
const subjectsToShare = ref<{ id: string; type: ResourceType }[]>([])
const isNotifyShare = ref<boolean>(true)
const isLoading = ref<boolean>(false)
const messageNotify = ref<string>('')

function clearFields() {
  subjectsToShare.value = []
  permissionsData.value = []
  messageNotify.value = ''
  isUnauthorize.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createBlock(ModalVue, {
    onClose: handleToggleModal,
    modalActive: _unref(modals)[_unref(modalName)],
    hasFooterBorder: false
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "pt-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(GhostButton, {
                    onClick: handleToggleModal,
                    width: "100%",
                    text: "Cancelar"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(FilledButton, {
                    onClick: () => {},
                    text: isShareContext.value ? 'Enviar' : 'Concluido',
                    height: "52px",
                    width: "100%",
                    disabled: 
                isLoading.value || isUnauthorize.value || !(!messageNotify.value || messageNotify.value.trim() === '')
              
                  }, null, 8, ["text", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (isUnauthorize.value)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            dense: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_alert, {
                color: "error",
                icon: "$warning",
                title: "Você não tem permissão para compartilhar este recurso..."
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            dense: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                md: subjectsToShare.value.length ? 10 : 12,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_autocomplete, {
                    modelValue: subjectsToShare.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((subjectsToShare).value = $event)),
                    "filter-keys": ['raw.title', 'raw.subtitle'],
                    label: "Adicionar Participantes ou Grupos",
                    color: "primary20",
                    variant: "outlined",
                    density: "compact",
                    "clear-on-select": "",
                    "menu-props": { closeOnContentClick: true },
                    chips: "",
                    "closable-chips": "",
                    multiple: "",
                    "hide-details": "",
                    clearable: "",
                    disabled: isLoading.value || !canEditCompanyAccess.value,
                    loading: isLoading.value
                  }, {
                    chip: _withCtx(({ props, item }) => [
                      _createVNode(_component_v_chip, _mergeProps({ color: "primary30" }, props, {
                        "prepend-icon": item.raw.icon,
                        text: item.raw.title
                      }), null, 16, ["prepend-icon", "text"])
                    ]),
                    item: _withCtx(({ props, item }) => [
                      _createVNode(_component_v_list_item, _mergeProps(props, {
                        "prepend-icon": item.raw.icon,
                        subtitle: item.raw.subtitle,
                        title: item.raw.title
                      }), null, 16, ["prepend-icon", "subtitle", "title"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "filter-keys", "disabled", "loading"])
                ]),
                _: 1
              }, 8, ["md"]),
              (subjectsToShare.value.length)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "12",
                    md: "2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_autocomplete, {
                        modelValue: permission.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((permission).value = $event)),
                        "auto-select-first": "",
                        items: permissionNewUsers.value,
                        "item-title": "label",
                        "item-value": "value",
                        color: "primary20",
                        density: "compact",
                        "hide-details": "",
                        chips: "",
                        variant: "outlined",
                        required: ""
                      }, {
                        chip: _withCtx(({ props, item }) => [
                          _createElementVNode("span", _mergeProps({ class: "flex items-center text-sm" }, props), _toDisplayString(item.raw.label), 17)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_Transition, {
                name: "slide-down",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "mt-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_textarea, {
                        modelValue: messageNotify.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((messageNotify).value = $event)),
                        class: "message-to-share",
                        color: "primary20",
                        label: "Mensagem",
                        disabled: !(subjectsToShare.value.length > 0)
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_v_checkbox, {
                        modelValue: isNotifyShare.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isNotifyShare).value = $event)),
                        color: "primary",
                        fieldId: "isNotify",
                        label: "Notificar",
                        disabled: !messageNotify.value || messageNotify.value.trim() === ''
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})